
export default function updateCategoryRecommendationSongs(payload, userId) {
    return {
        type : "UPDATE_CATEGORY_RECOMMENDATION_SONGS",
        payload : payload,
        userId : userId
    }
}




// WEBPACK FOOTER //
// ./src/actions/recommendations/updateCategoryRecommendationSongsAction.js